import React from "react";
import { Modal, Carousel, Button } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Import icons for navigation
import "./ProjectModal.css"; // Add a CSS file for custom styles

import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectModal({
  show,
  handleClose,
  images,
  title,
  description,
  ghLink,
  demoLink,
}) {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Carousel
          prevIcon={<FaChevronLeft className="carousel-control-icon" />}
          nextIcon={<FaChevronRight className="carousel-control-icon" />}
        >
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <div className="carousel-image-container">
                <img
                  className="carousel-image"
                  src={image}
                  alt={`Slide ${index}`}
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <p className="mt-3">{description}</p>
        <div className="text-center mt-4">
          <Button
            variant="primary"
            href={demoLink}
            target="_blank"
            className="modal-button"
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
          <Button
            variant="primary"
            href={ghLink}
            target="_blank"
            className="modal-button"
          >
            <BsGithub /> &nbsp; GitHub
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProjectModal;